import { CoreType } from "../../Core/Core.Interfaces";
import { GenericTableSchemaInterface } from "../../Table/Table.Interfaces";
import { VarKey } from "../../Variables/Generated/VarKey.Data";

export const FMSPlusMoveIn00Table: GenericTableSchemaInterface = {
  id: "fms-plus-move-in-00",
  name: "FMS+ Move In 00",
  description: "This table contains data regarding how many people were sent emails and texts messages via our FMS+ Move In workflows.",
  core: CoreType.STORAGE,
  // bot:"all",
  mapping: {
    c01: {
      name: "Operator Name",
      variable: VarKey.OrgName
    },
    c02: {
      name: "Facility ID",
      variable: VarKey.LocationFMSId
    },
    c03: {
      name: "Tenant ID",
      variable: VarKey.TenantId
    },
    c04: {
      name: "Day of move-in SMS"
    },
    c05: {
      name: "1 day after move-in SMS"
    },
    c06: {
      name: "3 days after move-in SMS"
    },
    c07: {
      name: "5 days after move-in SMS"
    },
    c08: {
      name: "7 days after move-in SMS"
    },
    c09: {
      name: "10 days after move-in SMS"
    },
    c10: {
      name: "14 days after move-in SMS"
    },
    c11: {
      name: "30 days after move-in SMS"
    },
    c12: {
      name: "Day of move-in Email"
    },
    c13: {
      name: "1 day after move-in Email"
    },
    c14: {
      name: "3 days after move-in Email"
    },
    c15: {
      name: "5 days after move-in Email"
    },
    c16: {
      name: "7 days after move-in Email"
    },
    c17: {
      name: "10 days after move-in Email"
    },
    c18: {
      name: "14 days after move-in Email"
    },
    c19: {
      name: "30 days after move-in Email"
    },
    c20: {
      name: "90 days after move-in SMS"
    },
    c21: {
      name: "90 days after move-in Email"
    },
    c22: {
      name: "SMS Link Clicked"
    },
    c23: {
      name: "Email Link Clicked"
    },
    c24: {
      name: "Review Solicitation"
    },
    c25: {
      name: "Referral Solicitation"
    }
  }
};
